/*----- Core -----*/
import uploadImageAsPromise from './uploadImage'

/*----- Components -----*/
import Notification from '../../components/commons/Notification'

/*----- Export -----*/
const imageLoader = (images, entityId, folderName, withSubfolder) => {
	
	return Promise.all(
			Array.from(images).map((image,index)=> uploadImageAsPromise(image, entityId, folderName, index, withSubfolder ))
		)
		.then( urls => urls)
		.catch((error) => {
			Notification(error.message, 'error')
			console.log(error.message)
		})
}
export default imageLoader